import type { Category } from '@/models'

const findCategoryByParentIdDeep = (
  category: Category,
  parentId: number,
): Undefinable<Category> => {
  if (!category.parent) return
  if (category.parent.id === parentId) return category

  return findCategoryByParentIdDeep(category.parent, parentId)
}

const useCategories = () => ({ findCategoryByParentIdDeep })

export { useCategories }
